import axios from 'axios';
import isDev from '../dev-detect';

export default axios.create({ withCredentials: isDev() });
